import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="sss" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">
            Sıkça Sorulan Sorular
          </h2>
          <p className="text-foreground-600 text-base">
            CiftlikWeb ile ilgili en çok merak edilen soruların cevaplarını burada bulabilirsiniz.
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggle(i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-50 transition-colors"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {item.question}
                </span>
                <div
                  className={`w-6 h-6 flex-shrink-0 flex items-center justify-center transition-transform duration-300 ${
                    openIndex === i ? 'rotate-45' : ''
                  }`}
                >
                  <i className="ri-add-line text-foreground-500 text-lg"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}